/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { DataContextProvider } from '@forge/data-connector';
import React from 'react';
import { ContextProvider, updateApiConfig } from '../../context/ApiContext';
import { UtilityAccountProvider } from '../../context/UtilityAccountContext/UtilityAccountContext';
import IEnergyManagementProps from '../DashboardKPIWidgets/IEnergyManagementProps';
import UtilityServiceSettingsComponent from './UtilityServiceSettingsComponent';
import { withLocalization } from '../../locales/withLocalization';

const UtilityServiceSettingsWidget = (props: IEnergyManagementProps) => {
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    emaasContext,
    parentPutAxios
  } = props;
  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <UtilityAccountProvider>
        <DataContextProvider config={connectorConfig}>
          <UtilityServiceSettingsComponent
            requestContext={requestContext}
            bearerToken={bearerToken}
            connectorConfig={connectorConfig}
            parentPutAxios={parentPutAxios}
          />
        </DataContextProvider>
      </UtilityAccountProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(
  UtilityServiceSettingsWidget
);
